import { toast } from "sonner";

import { changeRecordRevision } from "@/redux/globalSlice";
import { AppDispatch } from "@/redux/store";
import { baseApi } from "@/services/baseApi";
import { fabricaApi } from "@/services/fabricaApi";
import {
  ActivityUpdatedEvent,
  DataEvent,
  HistorianRecordStored,
  RecordUpdatedEvent,
} from "@/types/types";

export const eventHandlers: Record<
  string,
  (event: DataEvent, dispatch: AppDispatch) => void
> = {
  "machine.record.activities": (data, dispatch) => {
    const activityEvent = data.event as ActivityUpdatedEvent["event"];
    dispatch(
      fabricaApi.util.upsertQueryData(
        "getRecordActivities",
        { expediente_id: activityEvent.expediente_id },
        {
          activities: activityEvent.activities,
          expediente_id: activityEvent.expediente_id,
          revision: activityEvent.revision,
          rules_version: activityEvent.version,
          timestamp: activityEvent.timestamp,
        }
      )
    );
  },
  "historian.record.stored": (data, dispatch) => {
    const recordEvent = data.event as HistorianRecordStored["event"];
    dispatch(
      baseApi.util.invalidateTags([
        { id: recordEvent.expediente_id, type: "Activities" },
      ])
    );
  },
  "record.review.updated": (data, dispatch) => {
    const recordEvent = data.event as RecordUpdatedEvent["event"];
    dispatch(changeRecordRevision(data.event.revision));
    toast.success(`Expediente actualizado`, {
      description: `Modificado por ${recordEvent.email}`,
    });
  },
};
